import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as notificationState from '../employee-detail.reducer';
import * as notificationReducer from '../reducers/notifications.reducer';

export const getNotifications = createSelector(notificationState.getNotificationState, notificationReducer.getNotifications);
